import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import { Form, Col,  } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown'
import css from '../AnuncioForm.module.css'
import { linkApi } from '../../config'

export default function Powers({ values, setFieldValue }) {
    const { user } = useContext(UserContext)
    const [powers, setPowers] = useState([])

    const handleDropdownChange = (e) => {
        setFieldValue('engine.power_cv', e.target.value)
        setFieldValue('version.id', '')
    }

    useEffect(() => {
        let segment = values.segment.id
        let years = values.registration.year
        let fuels = values.fuel.id

        const postData = async () => {
            const options = {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + user.token,
                },
            }

            const res = await fetch(
                `${linkApi}/v1/cars/powers/${segment}/?ano=${years}&combustivel=${fuels}`,
                options
            )
                .then((response) => response.json())
                .catch((err) => console.error(err))

            setPowers(res.data)
        }
        postData()
    }, [
        user.token,
        values.segment.id,
        values.registration.year,
        values.fuel.id,
    ])

    return (
        <div>
            <Form.Group as={Col} controlId="validationFormik03">
                <Form.Label className={css.label}>Potência</Form.Label>
                <Dropdown
                    value={values.engine.power_cv}
                    onChange={handleDropdownChange}
                    options={powers}
                    placeholder="Escolher"
                    optionLabel="amount"
                    optionValue="amount"
                    filter
                    // disabled
                    className="w-full md:w-14rem"
                    style={{ width: '-webkit-fill-available' }}
                />
            </Form.Group>
        </div>
    )
}
